export const NomalQuestionConfig = [
  {
    title: '如何还车？',
    content: '租赁成功后如需退车，你可以在租车服务一栏，点击【租约变更】-【我要退车】预约退车时间，预约成功后，根据预约时间联系门店进行还车',
  },
  {
    title: '还车成功后，为什么还有账单结算？',
    content: '你的合同解除后，如果你还有未结清租金或违章、事故未及时处理等带来的费用，需要通过账单核算后进行结清。',
  },
  {
    title: '押金什么时候退？',
    content: '还车后，你的押金将会由所属签约公司根据结算情况退还，具体的到账时间以公司实际规定时间为准。',
  },
  {
    title: '押金会全额退回吗？什么情况下扣押金？',
    content: '租赁过程中，若你有未缴纳的相关费用，所属签约公司会在退车核算时从押金中扣除，剩余费用会全额退。',
  },
  {
    title: '押金是由谁收取和退还？',
    content: '你的押金是由所属签约公司收取和退还，平台当前仅提供线上支付的功能。',
  },
  {
    title: '租车时如何缴纳租金？',
    content: '你在签约完成后支付第一笔租金，在＜确认支付＞页面进行线上支付也可联系业务人员进行线下缴款。',
  },
  {
    title: '提车后，如何缴纳租金？',
    content: '你可以在＜租中＞页面﹣-＜待确认账单＞模块中点击【立即缴纳】/【提前缴纳】按钮进行支付，也可联系司管进行线下缴纳。',
  },
  {
    title: '租车需知的网约车政策',
    content: '根据网约车新政要求：用户驾龄未满3年或驾驶证最近连续3个记分周期内有记满12分记录，不允许从事网约车驾驶工作。建议租车的用户下单前确认本人驾驶证的扣分情况，如因用户驾驶证扣分原因导致不符合司机准入标准而产生的退车，相应退车费用由租车用户（自行）承担。',
  },
]
